<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      v-if="filled"
      d="M14.0161 3C7.93187 3 3 7.91975 3 13.9881C3 18.6438 5.90197 22.6203 10.0004 24.2199C9.90389 23.35 9.81751 22.0172 10.0381 21.0675C10.2393 20.2086 11.3301 15.6069 11.3301 15.6069C11.3301 15.6069 11.0002 14.9469 11.0002 13.9743C11.0002 12.4499 11.8888 11.3059 12.9924 11.3059C13.9334 11.3059 14.3873 12.0108 14.3873 12.8533C14.3873 13.7965 13.7873 15.2063 13.4758 16.5126C13.2139 17.6062 14.0271 18.4972 15.1068 18.4972C17.0623 18.4972 18.5694 16.4392 18.5694 13.4674C18.5694 10.8448 16.6736 9.00417 13.9674 9.00417C10.8338 9.00417 8.99691 11.3527 8.99691 13.7699C8.99691 14.7168 9.35897 15.7343 9.81383 16.2825C9.90481 16.3925 9.91675 16.4888 9.89194 16.5988C9.80924 16.9425 9.6227 17.6978 9.58502 17.8482C9.53632 18.0544 9.42697 18.0966 9.21653 17.9994C7.84274 17.3669 6.98079 15.3613 6.98079 13.7406C6.98079 10.2792 9.50599 7.09292 14.2587 7.09292C18.0796 7.09292 21.0514 9.81267 21.0514 13.439C21.0514 17.2294 18.6557 20.2792 15.3237 20.2792C14.2081 20.2792 13.1606 19.7026 12.7893 19.0151L12.101 21.6258C11.8538 22.5837 11.1784 23.7817 10.7245 24.5096C11.7564 24.8258 12.8435 25 13.9867 25C20.058 25 25 20.0821 25 14.0119C25 7.94083 20.058 3.02383 13.9867 3.02383L14.0161 3Z"
      :fill="color"
    />
    <path
      v-else
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25ZM4 13.9892C4 8.4725 8.48352 4 14.0146 4L13.9879 4.02167C19.5073 4.02167 24 8.49167 24 14.0108C24 19.5292 19.5073 24 13.9879 24C12.9487 24 11.9604 23.8417 11.0223 23.5542C11.4349 22.8925 12.049 21.8033 12.2737 20.9325L12.8994 18.5592C13.2369 19.1842 14.1892 19.7083 15.2034 19.7083C18.2325 19.7083 20.4103 16.9358 20.4103 13.49C20.4103 10.1933 17.7087 7.72083 14.2352 7.72083C9.91454 7.72083 7.6189 10.6175 7.6189 13.7642C7.6189 15.2375 8.40249 17.0608 9.65139 17.6358C9.8427 17.7242 9.94211 17.6858 9.98638 17.4983C10.0206 17.3617 10.1902 16.675 10.2654 16.3625C10.288 16.2625 10.2771 16.175 10.1944 16.075C9.78088 15.5767 9.45174 14.6517 9.45174 13.7908C9.45174 11.5933 11.1217 9.45833 13.9703 9.45833C16.4306 9.45833 18.154 11.1317 18.154 13.5158C18.154 16.2175 16.7839 18.0883 15.0062 18.0883C14.0246 18.0883 13.2853 17.2783 13.5234 16.2842C13.6254 15.8565 13.7614 15.4167 13.8937 14.9888C14.1288 14.2286 14.3521 13.5062 14.3521 12.9575C14.3521 12.1917 13.9394 11.5508 13.084 11.5508C12.0807 11.5508 11.2729 12.5908 11.2729 13.9767C11.2729 14.8608 11.5728 15.4608 11.5728 15.4608C11.5728 15.4608 10.5812 19.6442 10.3982 20.425C10.1977 21.2883 10.2763 22.5 10.364 23.2908C6.63815 21.8367 4 18.2217 4 13.9892Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    filled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
